import React, {useEffect, useRef, useState} from "react";
import {Button, Card, Col, Form, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import {Table} from "../../../components/tables";
import {SortableTh} from "../../../components/SortableTh";
import {formatDateTime} from "../../../utils/util";
import axios from "../../../utils/apiClient";
import Modals from "../../../components/modals";
import {SessionStorageUtil} from "../../../utils/localStorageUtil";
import {IMPERSONATION_KEY, useAuth} from "../../../context/authContext";
import {TRACK_EVENTS, trackPendoEvent} from "../../../utils/pendoTrack";

const componentName="UpdateUser";
const isEmpty = require("is-empty");

async function startImpersonation(targetUsername) {
  const params = new URLSearchParams();
  params.append('targetUsername', targetUsername);
  params.append('impersonationActive', 'true');

  const res = await axios.post(
    `${process.env.REACT_APP_REST_API_BASE_URL}/v1/impersonate/user`,
    params
  );

  const impersonationToken = res.headers['x_impersonation_token'] || res.data?.token;
  if (!impersonationToken) {
    throw new Error('Impersonation token not found in response');
  }
  axios.defaults.headers['Authorization'] = `Bearer ${impersonationToken}`;

  // Persist it to survive refreshes
  SessionStorageUtil.setObj(IMPERSONATION_KEY, impersonationToken);
  trackPendoEvent(TRACK_EVENTS.AUTH_IMPERSONATION_START, {
    route: window?.location?.pathname,
    source_module: "UpdateUser.startImpersonation"
  });
}

export const UpdateUser = ({
  updateStatus,
  handleModal,
  users,
  handleChangeCheckBox,
  showAddUpdateButtons,
  enableActDeactButton,
  sortCol,
  usersToActivateOrD,
  setSortOrder
}) => {
  const auth = useAuth();
  const cb = useRef([]);
  const scb = useRef();
  const selectAll = (m) => {
    cb.current.forEach((e) => {
      e.el.checked = m.currentTarget.checked;
      handleChangeCheckBox({ target: m.currentTarget }, e.user.userAccountId);
    });
  };
  const [showImpersonateConfirmation, setShowImpersonateConfirmation] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  //Check If currentUsers Exists, & If Not Dispatches getUsers

  useEffect(() => {
    if (cb) {
      cb.current.forEach((e) => {
        e.el.checked = false;
      });
    }
    if (scb && scb.current) {
      scb.current.checked = false;
    }
  }, [users]);
  // since it is an array we need to method to add the refs
  const addToRefs = (el, user) => {
    if (el && !cb.current.includes(el)) {
      cb.current.push({ el: el, user: user });
    }
  };
  const sortColl = (el, so) => {
    setSortOrder({
      el,
      so: so==='DESC'? true : false
    });
    sortCol(el, so==='DESC'? true : false);
  };

  const handleImpersonateUserClick = async (username) => {
    try {
      await startImpersonation(username);
      window.location.href = "/all_patients"; 
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Body>
        <Row className="mb-3">
          <Col sm={6}>
            <Form.Group hidden={!showAddUpdateButtons}>
              <Button id={`${componentName}-bulkUpdateUserButton`}
                onClick={() => handleModal("BULK UPDATE USER")}
                disabled={!enableActDeactButton}
                className="me-2"
              >
                Update User
              </Button>
              <Button id={`${componentName}-addUserButton`} onClick={() => handleModal("ADD USER")}>Add User</Button>
            </Form.Group>
          </Col>
          <Col sm={6} className="text-end">
            <Form.Group>
              <Button
                id={`${componentName}-activateButton`}
                variant="primary"
                onClick={() => updateStatus("Activate")}
                disabled={!enableActDeactButton}
                className="me-2"
              >
                Activate
              </Button>
              <Button
                id={`${componentName}-deactivateButton`}
                variant="primary"
                onClick={() => updateStatus("Deactivate")}
                disabled={!enableActDeactButton}
              >
                Deactivate
              </Button>
            </Form.Group>
          </Col>
        </Row>
        {!users || !users.length || users[0] === "Empty" ? null : (
          <>
            <Table className="table-bordered">
              <thead className="table-light">
                <tr>
                  <th scope="col" data-tablesaw-priority="persist">
                    <input
                      hidden={!showAddUpdateButtons}
                      checked={usersToActivateOrD}
                      onChange={(e) => selectAll(e)}
                      className="form-check-input"
                      type="checkbox"
                      id={`${componentName}-selectAllCheckbox`}
                      ref={scb}
                    />
                    <label htmlFor="basic_checkbox_1"></label>
                  </th>
                  <SortableTh  sortColumn ={sortColl} fieldName="email"  columnName="User ID" id={`${componentName}-emailColLabel`}/>
                  <SortableTh sortColumn ={sortColl} fieldName="lastName"  columnName="Name" id={`${componentName}-nameColLabel`}/>
                  {auth.getHasImpersonationAccess() && (
                    <SortableTh columnName="Impersonate" id={`${componentName}-impersonateColLabel`}/>
                  )}
                  <SortableTh columnName="Access Type" id={`${componentName}-accessTypeColLabel`}/>
                  <SortableTh columnName="Identifier" id={`${componentName}-identifierColLabel`}/>
                  <SortableTh columnName="Role" id={`${componentName}-roleColLabel`}/>
                  <SortableTh columnName="Last Login" id={`${componentName}-lastLoginColLabel`}/>
                  <SortableTh columnName="Status" id={`${componentName}-statusColLabel`}/>
                </tr>
              </thead>
              <tbody className="border-top-0">
                {users.map((user, idx) => {
                  return (
                    <tr key={user.userAccountId || user.id || user.userName || idx}>
                      <td>
                        {" "}
                        <input
                          ref={(e) => addToRefs(e, user)}
                          type="checkbox"
                          className="form-check-input"
                          name={user.id}
                          id={`${componentName}-selectCheckBox-${idx}`}
                          onChange={(e) =>
                            handleChangeCheckBox(e, user.userAccountId)
                          }
                        />
                        <label htmlFor="basic_checkbox_2"></label>
                      </td>
                      <td id={`${componentName}-emailValue=${idx}`} className="text-primary cursor-p" onClick={() => handleModal("UPDATE USER", user)}>
                        {user.userName}
                      </td>
                      <td id={`${componentName}-nameValue-${idx}`}>
                        {user.lastName && user.firstName
                          ? user.lastName + ", " + user.firstName
                          : null}
                      </td>
                      {auth.getHasImpersonationAccess() && (
                        <td id={`${componentName}-impersonateValue-${idx}`} className="text-center">
                          <OverlayTrigger placement="auto" overlay={<Tooltip>Impersonate User</Tooltip>}>
                            <Button id={`${componentName}-impersonateUserButton`} variant="link" onClick={() => {setSelectedUser(user); setShowImpersonateConfirmation(true);}}>
                              <i className="fa-solid fa-circle-user fa-lg"></i>
                            </Button>
                          </OverlayTrigger>
                        </td>
                      )}
                      <td id={`${componentName}-accessTypeValue-${idx}`}>{user.accessType ? user.accessType : null}</td>
                      <td id={`${componentName}-identifierValue-${idx}`}>{user.identifier ? user.identifier : null}</td>
                      <td id={`${componentName}-roleValue-${idx}`}>{user.userRole ? user.userRole.name : null}</td>
                      <td id={`${componentName}-lastLoginValue-${idx}`}>{!isEmpty(user.lastLoginTime) && formatDateTime(user.lastLoginTime)}</td>
                      {!user.accountActive ? (
                        <td id={`${componentName}-statusValue-${idx}`} className="text-danger">Inactive</td>
                      ) : (
                        <td id={`${componentName}-statusValue-${idx}`} className="text-success">Active</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <Modals
              show={showImpersonateConfirmation}
              hideFooter={false}
              onCreate={() => {if (selectedUser) {handleImpersonateUserClick(selectedUser.userName);}}}
              onHide={() => {setShowImpersonateConfirmation(false); setSelectedUser(null);}}
              centered={true}
              title="Confirm"
              titleid={`${componentName}-confirmImpersonation`}
              completeBtn="Confirm"
              completeBtnId={`${componentName}-confirmImpersonationButton`}
              closeBtn="Cancel"
              closeBtnId={`${componentName}-cancelImpersonationButton`}
              body={selectedUser ? `Are you sure you want to Impersonate ${selectedUser.firstName ?? ""} ${selectedUser.lastName ?? ""}?` : "Are you sure you want to Impersonate this user?"}
            />
          </>
        )}
        {users && users.length > 0 && users[0] === "Empty" && (
          <div>
            <Card>
              <Card.Body>
                <h2>User Is Not Available</h2>
              </Card.Body>
            </Card>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default UpdateUser;
